module.exports = __webpack_public_path__ + "static/media/inventory.61700730.svg";